interface Props {
  children: React.ReactNode;
  className?: string;
  as?: "h1" | "h2" | "h3";
}

const Heading: React.FC<Props> = ({ children, className = "", as = "h2" }) => {
  const Tag = as;
  return (
    <Tag
      className={`font-heading font-bold tracking-tight text-transparent bg-clip-text bg-gradient-to-b from-white via-white to-zinc-400 ${className}`}
    >
      {children}
    </Tag>
  );
};

export default Heading;
